import Alpine from 'alpinejs';


Alpine.data('TeamMembers', () => ({
    tiltItems: null,
    section: null,
    mouseX: 0,
    mouseY: 0,
    currentX: 0,
    currentY: 0,
    init(){
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

            // If user prefers reduced motion, do NOT start the JS animation loop.
            // We can just exit early.
            if (prefersReducedMotion.matches) {
                return;
            }

            this.section = document.querySelector('.module-teamMembers');
            this.tiltItems = this.$el.querySelectorAll('.js-tilt-container');

            this.section.addEventListener('mousemove', (e) => {
                this.mouseX = (e.clientX / window.innerWidth) - 0.5;
                this.mouseY = (e.clientY / window.innerHeight) - 0.5;
                this.animate();
            });
            
    },
    animate() {
        // Lower dampening for smoother, more subtle feel
        this.currentX = this.currentX + (this.mouseX - this.currentX) * 0.1;
        this.currentY = this.currentY + (this.mouseY - this.currentY) * 0.1;

        this.tiltItems.forEach(item => {
            const depth = parseFloat(item.getAttribute('data-depth')) || 0.5;
            const width = parseFloat(item.getAttribute('data-width')) || 100;
            const height = parseFloat(item.getAttribute('data-height')) || 100;

            const xOffset = this.currentX * width * depth; 
            const yOffset = this.currentY * height * depth;
            const rotateX = this.currentY * -20 * depth; 
            const rotateY = this.currentX * 20 * depth;

            item.style.transform = `
                translate3d(${xOffset}px, ${yOffset}px, 0)
                rotateX(${rotateX}deg) 
                rotateY(${rotateY}deg)
            `;
        });

        requestAnimationFrame(this.animate.bind(this));
    }
}));